<nb-card class="main card-scroll">
	<nb-card-header class="d-flex">
		<ngx-back-navigation></ngx-back-navigation>
		<h4>
			{{ 'PROPOSALS_PAGE.EDIT_PROPOSAL.EDIT_PROPOSAL' | translate }}
		</h4>
	</nb-card-header>

	<nb-card-body>
		<form [formGroup]="form" *ngIf="form">
			<div class="row">
				<div class="col-sm-3">
					<div class="form-group">
						<label class="label">{{
							'PROPOSALS_PAGE.EDIT_PROPOSAL.AUTHOR' | translate
						}}</label>
						<div>{{ proposal.author }}</div>
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<label class="label">{{
							'PROPOSALS_PAGE.EDIT_PROPOSAL.JOB_POST_URL'
								| translate
						}}</label>
						<input
							nbInput
							fullWidth
							type="text"
							placeholder="{{
								'PROPOSALS_PAGE.EDIT_PROPOSAL.PLACEHOLDER.JOB_POST_URL'
									| translate
							}}"
							formControlName="jobPostUrl"
							autocomplete="on"
						/>
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<label class="label">{{
							'PROPOSALS_PAGE.EDIT_PROPOSAL.PROPOSAL_SENT_ON'
								| translate
						}}</label>
						<div>{{ proposal.valueDate | date: 'shortDate' }}</div>
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<label class="label">{{
							'POP_UPS.CONTACT' | translate
						}}</label>
						<ng-select
							[addTag]="addNewOrganizationContact"
							[items]="organizationContacts"
							bindLabel="name"
							[searchable]="true"
							formControlName="organizationContact"
							(change)="selectOrganizationContact($event)"
							placeholder="{{ 'POP_UPS.CONTACT' | translate }}"
							appendTo="body"
						>
							<ng-template
								ng-option-tmp
								let-item="item"
								let-index="index"
							>
								{{ item.name }}
							</ng-template>
							<ng-template ng-label-tmp let-item="item">
								<div class="selector-template">
									<span>{{ item.name }}</span>
								</div>
							</ng-template>
						</ng-select>
					</div>
				</div>
				<div class="col-sm-3">
					<div class="form-group">
						<ga-tags-color-input
							[selectedTags]="tags"
							(selectedTagsEvent)="selectedTagsEvent($event)"
							[isOrgLevel]="true"
						>
						</ga-tags-color-input>
					</div>
				</div>
				<div class="row text-editors">
					<div class="col-sm-6">
						<div class="form-group">
							<label class="label">{{
								'PROPOSALS_PAGE.EDIT_PROPOSAL.JOB_POST_CONTENT'
									| translate
							}}</label>
							<ckeditor
								formControlName="jobPostContent"
								[config]="ckConfig"
							>
							</ckeditor>
						</div>
					</div>
					<div class="col-sm-6">
						<div class="form-group">
							<label class="label">{{
								'PROPOSALS_PAGE.EDIT_PROPOSAL.PROPOSAL_CONTENT'
									| translate
							}}</label>
							<ckeditor
								formControlName="proposalContent"
								[config]="ckConfig"
							></ckeditor>
						</div>
					</div>
				</div>
			</div>
		</form>
	</nb-card-body>
	<nb-card-footer class="text-right">
		<button
			[disabled]="form ? form.invalid : true"
			(click)="editProposal()"
			class="edit-btn"
			status="success"
			nbButton
		>
			{{
				'PROPOSALS_PAGE.EDIT_PROPOSAL.EDIT_PROPOSAL_BUTTON' | translate
			}}
		</button>
	</nb-card-footer>
</nb-card>
